<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12 sm8 md8 lg8>
        <v-card height="374">
          <v-card-text>
            <h4 class="subheading py-2">
              <v-icon class="mr-1">fas fa-tasks</v-icon>
              待办事项
            </h4>
            <v-divider/>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm4 md4 lg4>
        <v-date-picker
          v-model="date"
          width="100%"
          locale="zh-cn"
        />
      </v-flex>

      <v-flex xs12 sm6 md6 lg8>
        <v-card height="285">
          <v-card-text>
            <h4 class="subheading py-2">
              <v-icon class="mr-1">fas fa-bolt</v-icon>
              快捷通道
            </h4>
            <v-divider/>
            <v-container fluid grid-list-sm style="padding-top:80px">
              <v-layout row wrap>
                <v-flex xs2>
                  <v-card flat to="/inte/intellectualManage">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large color="blue">fas fa-file-alt</v-icon>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer/>
                      知识产权管理
                      <v-spacer/>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>

      <!--  知识产权年度统计 -->
      <v-flex xs12 sm6 md6 lg4>
        <v-card>
          <v-card-text>
            <five-year-by-type/>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>

  import FiveYearByType from '../inte/rept/FiveYearByType'

  export default {
    name: "Index",
    components: {
      FiveYearByType
    },
    data() {
      return {
        date: '2018-06-12'
      }
    }
  }
</script>
